import { ROUTES } from 'services/utils/enums';
import { sendRequest } from 'services/api';

export const getNotifications = async () => {
    return sendRequest(ROUTES.GET_NOTIFICATIONS);
};

export const markNotificationAsRead = async (id) => {
    return sendRequest(ROUTES.MARK_NOTIFICATION_AS_READ, id);
};

export const markNotificationAsReadByMessageId = async (messageId) => {
    return sendRequest(ROUTES.MARK_NOTIFICATION_AS_READ_BY_MESSAGE_ID, messageId);
};

export default {
    getNotifications,
    markNotificationAsRead,
    markNotificationAsReadByMessageId,
};
